import { useState, useEffect} from 'react';
import Barchart from '../Barchart';
import Doughnutchart from '../Doughnutchart';
import CustomTable from "../CustomTable"
import LineChart from './LineChart';


function FetchNutsCharts({TimeOption, RegionIndicator, Time, MeasurementIndicator, AirportCode, chartType, NutsSelection}) {
    
    const [userData, setUserData] = useState([]);

    const [excelDataChart,setexcelDataChart] = useState([]);


    let component;

    
    console.log("NUTS SELECTION", NutsSelection)


    // Code to match nut codes with selections

   

    useEffect(() => {
        
        //Url for getting Data for all airports
        var url = '/api/get_nut_indicator_by_year/' +Time+"/"+ MeasurementIndicator ;

        fetch(url).then((res) =>
           res.json().then((res) => {

            let matchedCodes = [];

            const codes =  {"Περιφέρεια 1 (Κωδικός 1)": "#Δ/Υ", "Περιφέρεια 2 (Κωδικός 2)": "EL41", "Περιφέρεια 3 (Κωδικός 3)": "EL42",
                "Περιφέρεια 4 (Κωδικός 4)": "EL43", "Περιφέρεια 5 (Κωδικός 5)": "EL51", "Περιφέρεια 6 (Κωδικός 6)": "EL52",
                "Περιφέρεια 7 (Κωδικός 7)": "EL54", "Περιφέρεια 8 (Κωδικός 8)": "EL61", "Περιφέρεια 9 (Κωδικός 9)": "EL62",
                "Περιφέρεια 10 (Κωδικός 10)": "EL63", "Περιφέρεια 11 (Κωδικός 11)": "EL65"}
    
            NutsSelection.forEach(string => {
                if (string in codes) {
                    matchedCodes.push(codes[string]);
                }
            });


            
            const keys = Object.keys(res.data.data);
            
            
            let listOfIds = []
            let listOfValues = []


            keys.forEach((code, i) => {
    
                //Check if code mataches our Airport Code
                if(matchedCodes.includes(code)) {
                    listOfValues.push(res.data.data[code])
                    listOfIds.push(code)
                }

            
                
                
            });


            setUserData({
                labels: listOfIds,
                datasets: [{
                  label: "",
                  data: listOfValues,
                  backgroundColor: "#0F8DD6",
                  borderColor: "black",
                  borderWidth: 0.1,
                }]
              })
            
            
            let exceldata = []
            for (let i = 0; i < listOfIds.length; i++) {
                exceldata.push({"Περιφέρεια": listOfIds[i], [MeasurementIndicator] : listOfValues[i]})
            }
            
            setexcelDataChart(exceldata)

           
          })
        )
        .catch((error) => {
          console.log("Refetching data for airport info!")
        });
      }, [Time, MeasurementIndicator, NutsSelection]);


    if(userData.length !== 0 && Time.length !== 0 ){

        switch (chartType) {
            case 0:
                userData.datasets[0].backgroundColor = ['#0F8DD6']
                let BarChartoptions = {
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                      legend : {
                       display: false,
                      }
                    }
                  }
                component = <Barchart chartData={userData} chartOptions = {BarChartoptions} excelData ={excelDataChart}> </Barchart>
           
            break;
            case 1:

                let Doughnutchartoptions = {maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                    legend: {
                        position: 'right',
                    },
                    }
                }
                
                
                userData.datasets[0].backgroundColor = ['#45474D',
                '#EFB7FF',
                'black',
                '#8D939C',
                'aqua',
                '#012D81',
                '#75D1D8',
                '#A471D1',
                '#FEAB7A',
                '#FF9B91']

                
                component = <Doughnutchart chartData={userData} chartOptions ={Doughnutchartoptions} excelData = {excelDataChart} ></Doughnutchart>

                
           
            
            break;
            case 2:
                let matrixData = []
                for (let i = 0; i < userData.labels.length; i++) {
                    matrixData.push({"Περιφέρεια": userData.labels[i], [MeasurementIndicator]: userData.datasets[0].data[i]})
                  }
                
                component = <CustomTable data = {matrixData}></CustomTable>
            
            break;
        
            case 3:
                
                userData.datasets[0].backgroundColor = ['#0F8DD6'] 
                let LineChartoptions = {
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                    legend : {
                    display: false,
                    }
                    }
                }
            
                component = <LineChart chartData={userData} chartOptions = {LineChartoptions} excelData ={excelDataChart}></LineChart>
            
            break;
            default:
            component = <h1>Παρακαλώ επιλέξτε τύπο διαγράμματος</h1>;
        }
       
        
        return (
            <div className="container filters-wrapper" style = {{marginTop: "5%"}}>
                <div style = {{display: "flex", marginTop: "3%"}}>
                    <div>
                        <p>Επιλεγμένη χρονική περίοδος</p>
                        <p><strong>{TimeOption}</strong></p>
                    </div>
                    <div style = {{marginLeft: "25%"}}>
                        <p>Επιλεγμένος δείκτης μέτρησης</p>
                        <p><strong>{RegionIndicator}</strong></p>
                    </div>
                </div>
                <div style = {{display: "flex"}}>
                    <div>
                        <p>Επιλεγμένη περίοδος</p>
                        <p><strong>{Time}</strong></p>
                    </div>
                    <div style = {{marginLeft: "32%"}}>
                        <p>Επιλεγμένοι δείκτες</p>
                        <p><strong>{MeasurementIndicator}</strong></p>
                    </div>

                </div>


                {component}
            
            </div>
        );
    }
    else {
        return <></>
    }
}

export default FetchNutsCharts;
